import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExpansionPanelNavItemComponent} from './expansion-panel-nav-item.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [ExpansionPanelNavItemComponent],
  imports: [CommonModule, MatExpansionModule, MatIconModule, RouterModule, TranslateModule],
  exports: [ExpansionPanelNavItemComponent],
})
export class ExpansionPanelNavItemModule {}
